function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "528.807px",
    height: "528.807px",
    viewBox: "0 0 528.807 528.807",
    style: {
      enableBackground: "new 0 0 528.807 528.807"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2373f7"
    },
    d: "M513.74,204.829l-29.482,29.486l-82.147-82.139l29.494-29.489c9.292-9.292,23.253-10.441,31.138-2.565l53.563,53.572 C524.179,181.567,523.032,195.537,513.74,204.829z M388.421,165.859l82.147,82.147l-195.883,195.88 c-0.898,0.898-3.393,3.393-6.892,4.285c-0.405,0.195-0.819,0.361-1.229,0.491l-102.23,32.58c-2.861,0.904-5.736,0.319-7.601-1.549 c-1.871-1.868-2.45-4.74-1.555-7.602l32.58-102.221c0.139-0.419,0.305-0.827,0.491-1.224c0.896-3.505,3.384-5.993,4.292-6.897 l36.812-36.812H105.02c-5.012,0-9.079-4.066-9.079-9.079c0-5.023,4.066-9.078,9.079-9.078h142.491L388.421,165.859z  M249.417,437.574l-50.569-50.561l-13.565,42.581l21.554,21.557L249.417,437.574z M385.265,198.508 c-2.908-2.911-7.625-2.911-10.527,0L222.03,351.206c-2.905,2.908-2.905,7.625,0,10.533c2.905,2.908,7.625,2.908,10.53,0 l152.705-152.699C388.172,206.129,388.172,201.413,385.265,198.508z M376.037,489.217c0,5.455-4.438,9.9-9.895,9.9H185.956 l-16.275,5.189c-3.269,1.041-6.629,1.566-9.992,1.566c-7.161,0-13.819-2.453-19.266-6.756H46.885c-5.458,0-9.909-4.434-9.909-9.9 V73.424c0-5.458,4.445-9.9,9.909-9.9h37.12v15.675c0,5.464,4.43,9.897,9.903,9.897c5.471,0,9.901-4.433,9.901-9.897V63.523h56.92 v15.675c0,5.464,4.43,9.897,9.901,9.897c5.473,0,9.903-4.433,9.903-9.897V63.523h49.497v15.675c0,5.464,4.43,9.897,9.904,9.897 c5.47,0,9.9-4.433,9.9-9.897V63.523h54.453v15.675c0,5.464,4.427,9.897,9.895,9.897c5.473,0,9.906-4.433,9.906-9.897V63.523h42.072 c5.45,0,9.896,4.442,9.896,9.9v68.571l10.379-10.374l19.322-19.325V73.424c0-21.831-17.762-39.596-39.597-39.596h-42.072V9.904 c0-5.467-4.434-9.904-9.906-9.904c-5.462,0-9.895,4.431-9.895,9.904v23.924h-54.465V9.904c0-5.467-4.43-9.904-9.901-9.904 c-5.473,0-9.903,4.431-9.903,9.904v23.924h-49.497V9.904c0-5.467-4.43-9.904-9.904-9.904c-5.47,0-9.9,4.431-9.9,9.904v23.924 h-56.92V9.904c0-5.467-4.431-9.904-9.901-9.904c-5.473,0-9.903,4.431-9.903,9.904v23.924h-37.12 c-21.832,0-39.602,17.765-39.602,39.596v415.787c0,21.834,17.771,39.596,39.602,39.596h319.264 c21.835,0,39.597-17.762,39.597-39.596V345.059l-29.702,29.708v114.45H376.037z M298.707,152.436H105.02 c-5.012,0-9.079,4.061-9.079,9.079c0,5.019,4.066,9.079,9.079,9.079h193.687c5.013,0,9.079-4.061,9.079-9.079 C307.786,156.497,303.72,152.436,298.707,152.436z M298.707,225.635H105.02c-5.012,0-9.079,4.063-9.079,9.079 c0,5.019,4.066,9.079,9.079,9.079h193.687c5.013,0,9.079-4.061,9.079-9.079C307.786,229.698,303.72,225.635,298.707,225.635z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.024ddaa4.svg";
export { ForwardRef as ReactComponent };